import { useState, useRef } from 'react';
import AdjustmentPanel from './AdjustmentPanel';
import adjustBrightnessEdited from 'assets/AdjustBrightnessEdited.png';
import adjustBrightnessDefault from 'assets/AdjustBrightnessDefault.png';
import { Tooltip } from '@mui/material';
import { useCameraFilters } from './useCameraFilters';
import styles from './BrightnessContrastAdjustmentButton.module.css';

export default function BrightnessContrastAdjustmentButton({ camId, videoWallCameras, visibleCameraIds, flags }) {
    const [isOpen, setIsOpen] = useState(null);
    const btnRef = useRef(null);
    const { getSettings, updateSetting, resetCamera, applyToAll, resetAll } = useCameraFilters(videoWallCameras);
    const brightnessContrasData = getSettings(camId);

    const cameraIds =
        visibleCameraIds?.camsConfig?.level1 || visibleCameraIds?.camsConfig?.level2
            ? [
                  ...(visibleCameraIds?.camsConfig?.level1?.map((el) => el.camId) || []),
                  ...(visibleCameraIds?.camsConfig?.level2?.map((el) => el.camId) || []),
              ]
            : visibleCameraIds?.map((el) => el.camId) || [];

    const isEdited = brightnessContrasData ? brightnessContrasData.brightness !== 0 || brightnessContrasData.contrast !== 0 : false;
    const isPanelOpen = isOpen === camId;

    const handleToggle = () => {
        setIsOpen((prev) => (prev === camId ? null : camId));
    };

    const getImageClassName = () => {
        let classes = [styles['adjustment-btn']];
        if (isEdited) {
            classes.push(styles['is-edited']);
        } else if (isPanelOpen) {
            classes.push(styles['is-open']);
        }
        return classes.join(' ');
    };

    return (
        <>
            {isPanelOpen ? (
                <img
                    ref={btnRef}
                    className={getImageClassName()}
                    onClick={handleToggle}
                    alt="Close adjustment panel"
                    src={isEdited ? adjustBrightnessEdited : adjustBrightnessDefault}
                />
            ) : (
                <Tooltip title="Brightness & Contrast" placement="bottom">
                    <img
                        ref={btnRef}
                        className={getImageClassName()}
                        onClick={handleToggle}
                        alt="Open adjustment panel"
                        src={isEdited ? adjustBrightnessEdited : adjustBrightnessDefault}
                    />
                </Tooltip>
            )}

            {isPanelOpen && (
                <AdjustmentPanel
                    flags={flags}
                    camId={camId}
                    anchorRef={btnRef}
                    onClose={() => setIsOpen(null)}
                    settings={brightnessContrasData}
                    videoWallCameras={videoWallCameras}
                    onUpdate={updateSetting}
                    onReset={resetCamera}
                    onApplyToAll={() => applyToAll(camId, cameraIds)}
                    onResetAll={() => resetAll(cameraIds)}
                />
            )}
        </>
    );
}
